import { render, staticRenderFns } from "./PfsFieldHelp.vue?vue&type=template&id=47ecf558&"
import script from "./PfsFieldHelp.vue?vue&type=script&lang=js&"
export * from "./PfsFieldHelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports